import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

// Barre de recherche native dans la nav bar (SearchComponent iOS). Chaque frappe
// native arrive par le callback ; on la recopie dans le champ web (masqué sur
// natif) dont l'event input laisse le contrôleur `search` existant piloter les
// résultats. Le placeholder part du champ : l'i18n reste côté Rails.
//
// Rejeu au `native:appeared` (cf. form_controller) : une page chargée pendant
// que l'app est en arrière-plan envoie son connect à une destination inactive,
// qui l'ignore — l'écran restait sans barre de recherche. Idempotent des deux
// côtés : iOS et Android gardent la barre déjà posée.
export default class extends BridgeComponent {
  static component = 'search'

  connect() {
    super.connect()

    this.field = this.element.querySelector('input[type="search"]')
    if (!this.field) return

    this.#sendConnect()
    this.pagePath = window.location.pathname
    // Only for the page this controller belongs to (see menu_controller).
    this.appearedHandler = () => { if (window.location.pathname === this.pagePath) this.#sendConnect() }
    window.addEventListener('native:appeared', this.appearedHandler, { once: true })
  }

  disconnect() {
    window.removeEventListener('native:appeared', this.appearedHandler)
    super.disconnect()
  }

  #sendConnect() {
    this.send('connect', { placeholder: this.field.placeholder }, ({ data: { query } }) => {
      this.field.value = query
      this.field.dispatchEvent(new Event('input', { bubbles: true }))
    })
  }
}
